import React, { useCallback } from 'react';
import { Select as MantineSelect, Tooltip } from '@mantine/core';

const widthFreeSelectComboxProps = {
  position: 'bottom-end',
  width: 'auto',
  minWidth: 200,
};

const selectClassNames = {
  dropdown: 'dark-select-dropdown !rounded',
  input: '!px-3 placeholder:!text-[#7f7f7f]',
};

export const Select = React.memo((props) => {
  const { title, tooltip, name, options, value, onChange } = props;

  const handleChange = useCallback(
    (value) => {
      onChange(value, name);
    },
    [name, onChange],
  );

  return (
    <div className="flex items-center">
      <Tooltip
        disabled={!tooltip}
        maw={300}
        multiline
        position="left-start"
        label={<span className="text-xs leading-[14px]">{tooltip}</span>}
      >
        <span className="w-[120px] mr-3 text-xs text-[#7f7f7f]">{title}</span>
      </Tooltip>
      <MantineSelect
        size="xs"
        value={value}
        data={options}
        onChange={handleChange}
        classNames={selectClassNames}
        placeholder={`请选择${title}`}
        className="cn-select bordered rounded flex-1"
        comboboxProps={widthFreeSelectComboxProps}
      />
    </div>
  );
});

export const SelectView = React.memo(({ title, value }) => {
  return (
    <>
      <div className="p-4 flex items-center justify-between">
        <h5 id="model-checkpoints-entry" className="text-[#2d2d2d] text-xs  leading-[14px] font-bold font-gro">
          {title}
        </h5>
        <span className="mt-3 block text-[#2d2d2d] text-xs font-normal">{value}</span>
      </div>
      <div className="border-t border-[#efefef]" />
    </>
  );
});
